module.exports = __webpack_public_path__ + "img/农机贷（个人）.b0b008c8.png";